export enum VisualsDistributionCategoryEnum {
    FULL_DISTRIBUTION = 'FULL_DISTRIBUTION',
    INCLUDE_ONLY_SELECTED = 'INCLUDE_ONLY_SELECTED',
    INCLUDE_ALL_EXCEPT_SELECTED = 'INCLUDE_ALL_EXCEPT_SELECTED',
    BACK_TO_BRAND_DISTRIBUTION = 'BACK_TO_BRAND_DISTRIBUTION',
}

export const VisualDistributionCategoryIndex: Record<string, number> = {
    [VisualsDistributionCategoryEnum.FULL_DISTRIBUTION]: 3,
    [VisualsDistributionCategoryEnum.INCLUDE_ALL_EXCEPT_SELECTED]: 1,
    [VisualsDistributionCategoryEnum.INCLUDE_ONLY_SELECTED]: 2,
    [VisualsDistributionCategoryEnum.BACK_TO_BRAND_DISTRIBUTION]: 4,
};

export function getVisualDistributionCategoryByIndex(index: number): VisualsDistributionCategoryEnum | undefined {
    const categoryKey = Object.keys(VisualDistributionCategoryIndex).find((key) => VisualDistributionCategoryIndex[key] === index);
    return categoryKey as VisualsDistributionCategoryEnum | undefined;
}

export function getVisualDistributionIndexByCategory(category: VisualsDistributionCategoryEnum): number | undefined {
    return VisualDistributionCategoryIndex[category];
}
